import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../api/adminService";
import "./AdminLogin.css";

const AdminLogin = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    setError("");
    setLoading(true);

    try {
      const data = await loginAdmin(username, password);

      localStorage.setItem("starGoldAdminToken", data.token);

      localStorage.setItem("starGoldAdminUsername", data.username);

      localStorage.setItem("starGoldAdminRole", data.role);

      navigate("/admin/dashboard");
    } catch (error) {
      console.error("Admin login error:", error);

      setError("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-logo">STAR GOLD</div>

        <p className="admin-title">Administration Panel</p>

        <form onSubmit={handleSubmit}>
          <div className="admin-form-group">
            <label>Username</label>

            <input
              type="text"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              placeholder="Enter username"
              required
            />
          </div>

          <div className="admin-form-group">
            <label>Password</label>

            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter password"
              required
            />
          </div>

          {error && <p className="admin-login-error">{error}</p>}

          <button
            type="submit"
            className="admin-login-button"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="admin-login-footer">STAR GOLD • Admin Access</p>
      </div>
    </div>
  );
};

export default AdminLogin;
